import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { IBranchModel } from "states/branch/branch.models";
import {
  ConfirmModel,
  GlobalValueState,
  ToastModel,
  ToastType,
} from "./global-value.models";
import { removeRefreshToken, removeToken } from "shared/plugins/http-service";

export const globalValueSlice = createSlice({
  name: "globalValue",
  initialState: {
    isLoading: false,
    preLoadingApp: true,
    isLoadingLocationParams:false,
    activeMenu: "",
    toast: {
      duration: 3000,
    } as ToastModel,
    confirm: {} as ConfirmModel,
    isSignIn: false,
  } as GlobalValueState,
  reducers: {
    setLoading(state, action: { payload: boolean }) {
      state.isLoading = action.payload;
    },
    setToast(state, action: { payload: ToastModel }) {
      state.toast = action.payload;
    },
    showSuccess(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        type: ToastType.success,
        isShowToast: true,
      };
    },
    showError(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        type: ToastType.error,
        isShowToast: true,
      };
    },
    showWarning(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        type: ToastType.warn,
        isShowToast: true,
      };
    },
    showInfo(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        type: ToastType.info,
        isShowToast: true,
      };
    },
    showConfirmModal(state, action: { payload: ConfirmModel }) {
      state.confirm = {
        ...action.payload,
        isModal: true,
      };
    },
    closeConfirmModal(state) {
      state.confirm = {
        ...state.confirm,
        isModal: false,
      };
    },
    showMenuDescriptionModal(state, action: { payload: string }){
      state.menuDescriptionModal = {
        ...state.menuDescriptionModal,
        open: true,
        description: action.payload,
      };
    },
    closeMenuDescriptionModal(state){
      state.menuDescriptionModal = {
        ...state.menuDescriptionModal,
        open: false,
        description: "",
      };
    },
    showOrderGuestModal(state) {
      state.visibleOrderGuestModal = true;
    },
    closeOrderGuestModal(state) {
      state.visibleOrderGuestModal = false;
    },
    logout(state) {
      removeToken();
      removeRefreshToken();
      state.isSignIn = false;
    },
    setLogin(state) {
      state.isSignIn = true;
    },
    preLoadingAppFinish(state) {
      state.preLoadingApp = false;
    },
    loadingLocationParams(state) {
      state.isLoadingLocationParams = true;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setLoading,
  setToast,
  showConfirmModal,
  closeConfirmModal,
  showError,
  showInfo,
  showSuccess,
  showWarning,
  logout,
  setLogin,
  loadingLocationParams,
  preLoadingAppFinish,
  closeMenuDescriptionModal,
  showMenuDescriptionModal,
  showOrderGuestModal,
  closeOrderGuestModal,
} = globalValueSlice.actions;

export const selectConfirmModal = (state: RootState) =>
  state.globalValue.confirm;

export const selectMenuDescriptionModal = (state: RootState) =>
  state.globalValue.menuDescriptionModal;

export const selectToast = (state: RootState) => state.globalValue.toast;
export const selectSignIn = (state: RootState) => state.globalValue.isSignIn;
export const selectVisibleOrderGuestModal = (state: RootState) => state.globalValue.visibleOrderGuestModal;

